import { useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

const TOPICS = {
  "tech-transfer": ["Technology Transfer", "Licensing", "EPC", "Procurement", "Market Entry", "Other"],
  "plant-advisory": ["Buy a Chemical Plant", "Sell a Chemical Plant", "Grow an Acquired Business", "Other"],
  default: ["Dashboards / Subscription", "Reports", "Consulting", "Tech Transfer", "Plant Advisory", "Other"],
};
const STAGES = ["Exploration", "Feasibility", "Partner Selection", "Engineering", "Execution"];
const field = "h-10 bg-slate-900 border-slate-700";

export function EnquiryForm({ context = "default", title = "Send us an enquiry" }) {
  const topics = TOPICS[context] || TOPICS.default;
  const [f, setF] = useState({ name: "", email: "", company: "", phone: "", country: "", topic: topics[0], project_stage: "", message: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/enquiries", f);
      toast.success("Thank you — our team will get back to you shortly.");
      setF({ ...f, message: "" });
    } catch (err) {
      toast.error(errMsg(err));
    }
    setBusy(false);
  };
  return (
    <form onSubmit={submit} className="bg-[#0F172A] border border-slate-800 rounded-lg p-6 md:p-8 space-y-4" data-testid="enquiry-form">
      <h3 className="text-xl font-bold">{title}</h3>
      <p className="text-xs text-slate-500">Confidentiality arrangements can be established before the exchange of sensitive information.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        <Input data-testid="enquiry-name" required placeholder="Name" value={f.name} onChange={set("name")} className={field} />
        <Input data-testid="enquiry-email" required type="email" placeholder="Business email" value={f.email} onChange={set("email")} className={field} />
        <Input data-testid="enquiry-company" placeholder="Company" value={f.company} onChange={set("company")} className={field} />
        <Input data-testid="enquiry-phone" placeholder="Phone" value={f.phone} onChange={set("phone")} className={field} />
        <Input data-testid="enquiry-country" placeholder="Country / target market" value={f.country} onChange={set("country")} className={field} />
        <select data-testid="enquiry-topic" value={f.topic} onChange={set("topic")} className={`${field} rounded-md border px-3 text-sm`}>{topics.map((t) => <option key={t}>{t}</option>)}</select>
        {context === "tech-transfer" && (
          <select data-testid="enquiry-stage" value={f.project_stage} onChange={set("project_stage")} className={`${field} rounded-md border px-3 text-sm sm:col-span-2`}>
            <option value="">Project stage</option>{STAGES.map((t) => <option key={t}>{t}</option>)}
          </select>
        )}
      </div>
      <Textarea data-testid="enquiry-message" required rows={5} placeholder="Brief description of your requirement and expected timeline" value={f.message} onChange={set("message")} className="bg-slate-900 border-slate-700" />
      <button disabled={busy} data-testid="enquiry-submit" className="px-6 h-11 rounded-md bg-[#1074BA] hover:bg-[#0D629E] text-white font-semibold flex items-center gap-2 disabled:opacity-60">
        <Send className="h-4 w-4" /> {busy ? "Sending…" : "Submit enquiry"}
      </button>
    </form>
  );
}
